import { Alert, Snackbar } from '@mui/material';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';

const FIRST_NAME_SELECTOR = 'input[name="firstName"]';
const EXPECTED_FIRST_NAME_PLACEHOLDER = 'John';

export const BrowserTranslationWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const hasWarned = useRef(false);

  useEffect(() => {
    const checkFirstNamePlaceholder = () => {
      if (hasWarned.current) {
        return;
      }

      const firstNameInput =
        document.querySelector<HTMLInputElement>(FIRST_NAME_SELECTOR);

      if (!firstNameInput) {
        return;
      }

      const placeholder = firstNameInput.getAttribute('placeholder');

      if (placeholder !== EXPECTED_FIRST_NAME_PLACEHOLDER) {
        hasWarned.current = true;
        setShowWarning(true);
      }
    };

    const observer = new MutationObserver(checkFirstNamePlaceholder);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['placeholder'],
      childList: true,
      subtree: true,
    });
    checkFirstNamePlaceholder();

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleClose = (_event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setShowWarning(false);
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      autoHideDuration={null}
      open={showWarning}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity="warning"
        sx={{ width: '100%' }}
        translate="no"
      >
        Please disable browser translation in this app for the best experience.
      </Alert>
    </Snackbar>
  );
};
